// Shared build-variant helpers for KGOnline web + MFSetu mobile apps.
export const APP_VARIANT = String(process.env.REACT_APP_APP_VARIANT || "web").toLowerCase();
export const APP_PLATFORM = String(process.env.REACT_APP_PLATFORM || "web").toLowerCase();
export const APP_VERSION_CODE = Number.parseInt(process.env.REACT_APP_VERSION_CODE || "0", 10) || 0;

export const IS_MFD_APP = APP_VARIANT === "mfd";
export const IS_MYWEALTH_APP = APP_VARIANT === "mywealth";
export const IS_MOBILE_APP = IS_MFD_APP || IS_MYWEALTH_APP;
